<div no-padding class="uploaded-imgs">
  <div class="img-node" *ngFor="let img of imgList">
      <ion-button *ngIf="showDelete" (click)="deleteImg(img)" size="small" fill="clear" no-box-shadow>
        <ion-icon size="small" name="close-circle" [style.color]="'#E5EAED'"></ion-icon>
      </ion-button>
      <img (click)="onImageClick(img)" [img-preloader]="img?.url"/>
  </div>
</div>
